import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect, CustomFormControl } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    additionalNotes: checkText(settings),
});

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Form.Label>Mein Wunsch-Standort</Form.Label>
            {

                values.fieldOfLocation.map((field, index) =>
                    <Form.Group className="mb-3" key={index}>
                        <Form.Check
                            name="location"
                            id={field.displayName}
                            label={field.displayName}
                            value={field.displayName}
                            isValid={touched.location && !errors.location}
                            isInvalid={errors.location}
                            onChange={(event) => {
                                field.onChange(event);
                                handleChange(event);
                            }}
                        />

                    </Form.Group>

                )
            }
            <Form.Group className="mb-3" controlId="formBecomingAwareThrough">
                <Form.Label>Wie hast du uns gefunden?</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name="becomingAwareThrough"
                    value={values.becomingAwareThrough}
                    isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                    isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.BecomingAwareThrough.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.becomingAwareThrough}
                </Form.Control.Feedback>
            </Form.Group>
            {values.becomingAwareThrough === "Sonstiges" && <Form.Group className="mb-3" controlId="formBecomingAwareThroughOther">
                <CustomFormControl
                    colors={colors}
                    placeholder="Bitte eingeben, wie du uns gefunden hast"
                    type="text"
                    name="becomingAwareThroughOther"
                    value={values.becomingAwareThroughOther}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.becomingAwareThroughOther && !errors.becomingAwareThroughOther}
                    isInvalid={touched.becomingAwareThroughOther && errors.becomingAwareThroughOther}
                    maxLength={20000}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.becomingAwareThroughOther}
                </Form.Control.Feedback>
            </Form.Group>}

            <Form.Group className="mb-3" controlId="formAdditionalNotes">
                <Form.Label>Sollten wir noch etwas wissen (z.B. Gehaltsvorstellung, frühester Eintrittstermin etc.)?</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Sollten wir noch etwas wissen?"
                    type="text"
                    name="additionalNotes"
                    value={values.additionalNotes}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.additionalNotes && !errors.additionalNotes}
                    isInvalid={touched.additionalNotes && errors.additionalNotes}
                    maxLength={20000}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.additionalNotes}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};